import {
  AbsoluteCenter,
  Box,
  Link,
  Text,
  useToken,
  VStack,
} from '@chakra-ui/react';
import { CloudinaryVideo } from '@time-line/components/common';
import type { AspectRatio } from '@time-line/components/types';
import type { SocialMediaStory } from 'types/cms/SocialMediaStory';

import { Container } from './Container';

const WIDTH = 240;

interface SocialMediaProps extends Omit<SocialMediaStory, '_type' | '_key'> {
  height: number;
  infoBoxHeight: number;
}

export const SocialMedia = ({
  handle,
  url,
  video,
  poster,
  height,
  infoBoxHeight,
}: SocialMediaProps) => {
  const infoBoxPadding = useToken('space', '4xs');
  const infoBoxPaddingNum = parseInt(infoBoxPadding.replace('px', ''));

  const outerHeight = height + infoBoxPaddingNum;
  const containerHeight = height - infoBoxHeight;

  const aspectRatio: AspectRatio = `${WIDTH}:${containerHeight}`;

  return (
    <Box width={WIDTH} height={outerHeight}>
      <Container height={containerHeight} insetBorder>
        <AbsoluteCenter width="100%">
          <CloudinaryVideo
            cloudinaryId={video.cloudinaryId}
            title={video.title}
            canPlay={false}
            aspectRatio={aspectRatio}
            poster={poster}
          />
        </AbsoluteCenter>
      </Container>
      {handle && (
        <VStack
          color="blackAlpha.700"
          position="absolute"
          width="100%"
          bottom={0}
          alignContent="center"
          justifyContent="center"
          height={`calc(${infoBoxHeight}px + ${infoBoxPadding})`}
          pt={infoBoxPadding}
        >
          <Link
            variant="unstyled"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Text size="detail">{handle}</Text>
          </Link>
        </VStack>
      )}
    </Box>
  );
};
